import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useConfirmation = (message: any) => {
  const history = useHistory();

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    const unblock = history.block(() => {
      return message;
    });
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      unblock();
    };
  }, [message, history]);
};

export default useConfirmation;